import { useInvalidateBrandAccountSurveyGroupsQuery } from '~/hooks/useBrandAccountSurveyGroupsQuery/useInvalidateBrandAccountSurveyGroupsQuery'

import { useCommonQueryCurrentBrandAccount } from '../useCommonQuery'

export const useInvalidateCurrentBrandAccountSurveyGroupsQuery = () => {
  const currentBrandAccount = useCommonQueryCurrentBrandAccount()

  return useInvalidateBrandAccountSurveyGroupsQuery(currentBrandAccount?.id)
}
